import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {CountryState} from "@/modules/regionsv2/country/state";
import {IdMapper} from "@/interfaces/state/base";
import {Country} from "@/interfaces/entity/country";
import {PaginationMeta} from "@/interfaces/common";
import {CountryParams} from "@/modules/regionsv2/country/params";
import {
    createCountryV2, deleteCountryV2,
    editCountryV2, listCountryV2,
} from "@/modules/regionsv2/country/services";
import { union, cloneDeep } from "lodash";

@Module({ dynamic: true, name: "country", store })
class CountryModule extends VuexModule implements CountryState {
    data: IdMapper<Country> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: CountryParams = new CountryParams();
    cachedData: IdMapper<Country> = {};

    get countries() {
        return this.ids.map((id) => this.data[id]);
    }

    @Mutation
    private MAP_COUNTRIES_V2(payload: any) {
        const data: IdMapper<Country> = { ...this.data };
        this.meta = payload.meta;
        this.ids = payload.datas.map((country: Country) => {
            data[country.id] = {
                ...country,
                isDeleting: false,
                isSaving: false,
                editable: false
            } as any;
            return country.id;
        });
        this.data = data;
        this.cachedData = cloneDeep(data);
    }

    @Mutation
    private UPDATE_COUNTRY_PARAMS_V2(params: any) {
        this.params = { ...params };
    }

    @Mutation
    private UPDATE_DATA_COUNTRY_V2({ key, value }: any) {
        this.data[key] = value;
    }

    @Mutation
    private UPDATE_CACHED_DATA_COUNTRY_V2({ key, value }: any) {
        this.cachedData[key] = value;
    }

    @Mutation
    private SET_COUNTRY_V2(payload: Country) {
        this.ids = union([payload.id], this.ids);
        this.data = { ...this.data, [payload.id]: payload }
    }

    @Mutation
    private DELETE_COUNTRY_V2(payload: Country) {
        this.ids = this.ids.filter((id) => id != payload.id);
        delete this.data[payload.id];
    }

    @Action({ rawError: true })
    public async getCountriesV2(params: any = {}) {
        const { data } = await listCountryV2(params);
        this.MAP_COUNTRIES_V2(data);
        return data.datas;
    }

    @Action({ rawError: true })
    public async createCountryV2(payload: any) {
        const { data } = await createCountryV2(payload);
        this.SET_COUNTRY_V2({ ...data.data, isDeleting: false, isSaving: false, editable: false });
        return data.data;
    }

    @Action({ rawError: true })
    public async editCountryV2(payload: any) {
        const { data } = await editCountryV2(payload);
        this.SET_COUNTRY_V2(data.data);
        return data.data;
    }

    @Action({ rawError: true })
    public async deleteCountryV2(id: number) {
        const { data } = await deleteCountryV2(id);
        this.DELETE_COUNTRY_V2(data.data);
        return data.data;
    }

    @Action({ rawError: true })
    public async paramsChangeV2(params: any) {
        this.UPDATE_COUNTRY_PARAMS_V2(params);
        await this.getCountriesV2(params);
    }

    @Action({ rawError: true })
    public updateDataCountryV2({ key, value }: any) {
        this.UPDATE_DATA_COUNTRY_V2({ key, value });
    }

    @Action({ rawError: true })
    public updateCachedDataCountryV2({ key, value }: any) {
        this.UPDATE_CACHED_DATA_COUNTRY_V2({ key, value });
    }
}

export const CountryStore = getModule(CountryModule)
